export const GET_COUNTRIES_START = "[COUNTRIES] START GET ALL COUNTRIES";
export const GET_COUNTRIES_SUCCESS = "[COUNTRIES] GET ALL COUNTRIES SUCCESS";
export const GET_COUNTRIES_FAILURE = "[COUNTRIES] GET ALL COUNTRIES FAILURE";